<template>
    <div v-if="data" class="d-flex">
        <div v-for="(event, index) in historyEvents"
             :key="index"
             class="mr-1">
            <i class="fas fa-circle fa-xs"
               data-toggle="popover"
               :title="getTitle(event)"
               :data-content="getContent(event)"
               :class="{'text-success':event.is_project, 'text-danger':!event.is_project}">
            </i>
        </div>
    </div>
</template>
<script>

let TestingHistory = require('@/mixins/TestingHistory')

export default {

    mixins: [TestingHistory],

    methods: {

        getContent(event) {

            var content = `<b>Number: </b>${event.data.number}.<br>`;

            if(event.is_project){
                content += `<b>Completed Date: </b>${this.shortDate(event.data.completed_at)}.<br>`;
                // City
                if (event.data.city) {content+= `<b>City: </b>${event.data.city}<br>`;}

                if(this.haveDaylightTest(event.data)){
                    content += `<b class="text-bluelight">Using Daylight Test</b><br>`;
                }

                return content
            }

            // Field Inspection
            content += `<b>Trigger Date: </b>${this.shortDate(event.data.notified_at)}.<br>`;

            // City
            if (event.data.city) {content+= `<b>City: </b>${event.data.city}<br>`;}


            return content
        },

        getTitle(event) {
            return `<span>${event.name}</span>`;
        }
    }

}
</script>
